module.exports = __webpack_public_path__ + "static/water_glacier23-5b21ea5be5731bbd6ff2c629fe1b532d.jpg";